import { getAnalytics, type Analytics } from 'firebase/analytics';
import { initializeApp, type FirebaseApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyA6qDfKNJ1swyb0wQd9GvpxBEqNu8U6DqM',
  authDomain: 'syncara-production.firebaseapp.com',
  projectId: 'syncara-production',
  storageBucket: 'syncara-production.firebasestorage.app',
  messagingSenderId: '650955231140',
  appId: '1:650955231140:web:77e795637ffa6f3d927b31',
  measurementId: 'G-TBH64064KY',
};

export const app: FirebaseApp = initializeApp(firebaseConfig);

let analyticsInstance: Analytics | null = null;
try {
  analyticsInstance = getAnalytics(app);
} catch (error) {
  // eslint-disable-next-line no-console
  console.warn('Firebase Analytics could not be initialized:', error);
}

export const analytics: Analytics | null = analyticsInstance;
